/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_ViewInputs */

const en_plan_view = /** @type {(inputs: Plan_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan view`)
};

const de_plan_view = /** @type {(inputs: Plan_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planansicht`)
};

/**
* | output |
* | --- |
* | "Plan view" |
*
* @param {Plan_ViewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_view = /** @type {((inputs?: Plan_ViewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_ViewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_view(inputs)
	return en_plan_view(inputs)
});